import {Avatar, Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, useTheme} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {useState, useRef, useEffect} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {EMPTY_ID, useGetTenant, useGetMe} from 'hooks/swr';
import copy from 'copy-to-clipboard';
import {useTranslation} from 'react-i18next';
import {getAuth0LogoutRedirect} from '../../../../utils/runtimeVars';

export const AppTopBarProfileMenu = () => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const {t} = useTranslation('common');
  const [open, setOpen] = useState(false);

  const {logout, user, getAccessTokenSilently} = useAuth0();
  const theme = useTheme();
  const [token, setToken] = useState<string>();

  const {data: me} = useGetMe({resourceId: EMPTY_ID});
  // Code Generator Issue
  // eslint-disable-next-line @typescript-eslint/dot-notation
  const {data: myCompany} = useGetTenant({resourceId: me?.tenantId});

  useEffect(() => {
    if (import.meta.env.NODE_ENV !== 'test') {
      getAccessTokenSilently()
        .then((token) => {
          setToken(token);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    handleClose();
    void logout({logoutParams: {returnTo: getAuth0LogoutRedirect()}});
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleToggle} size="small" data-testid="user-name-menu" ref={anchorRef}>
        <Avatar
          sx={{width: 32, height: 32, bgcolor: theme.palette.primary.main}}
          alt={user?.name}
          src={user?.picture}
        />
      </IconButton>
      <Menu open={open} anchorEl={anchorRef.current} onClose={handleClose} sx={{zIndex: 3000}}>
        <Box
          onClick={() => {
            token && copy(token);
          }}
        >
          <MenuItem disabled>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText>{user?.name}</ListItemText>
          </MenuItem>
        </Box>
        <MenuItem disabled>
          <ListItemIcon>
            <BusinessIcon />
          </ListItemIcon>
          <ListItemText>{myCompany?.name}</ListItemText>
        </MenuItem>

        <Divider variant="middle" />

        <MenuItem data-testid="appbar-logout" onClick={handleLogout}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText>{t('logOut')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
